import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteLogin } from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../../app.helpers";
import { CalendarFechaNacParametros } from "../../../components/common/utils/calendarFechaNacParametros";
import { DetallesProductosGenerales } from "../datosGenerales/entities/detalle_otros_ramos_entity";
import { RenovacionService } from "./renovacion.service";
import { UtilService } from "../../../components/common/utils/util.service";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";
import { DatosGeneralesService } from "../datosGenerales/datos-generales.service";
import { ClienteIndividualEntity } from "../datosGenerales/entities/datos_generales_individual_entity";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ProductosGeneralesEntity } from "../datosGenerales/entities/productos_generales_entity";
import { UsuarioLoginEntity } from "../../login/usuario_login_entity";

const swal = require("sweetalert2");

declare var jQuery: any;

@Component({
    selector: 'renovacionOtrosRamos',
    providers: [RenovacionService],
    templateUrl: 'renovacion-otros-ramos.template.html',
    styleUrls: ["renovacion.style.css"]
})

export class RenovacionOtrosRamos implements OnInit {

    usuario: ClienteLogin;
    clienteMasivosIndividual: ClienteIndividualEntity;
    otroRamoOriginal: DetallesProductosGenerales;
    otroRamoModificado: DetallesProductosGenerales;
    editar: boolean;
    otrosRamos: ProductosGeneralesEntity;
    usuarioLogin: UsuarioLoginEntity;

    constructor(private renovacionService: RenovacionService,
        public utilsService: UtilService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private consultarMasivo: ConsultarUsuarioMasivos,
        private datosGeneralesIndividualSevice: DatosGeneralesService,
        public sesionStorageService: SessionStorageService) { }

    ngOnInit() {
        try {
            /*correctHeight();
            detectBody();*/
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            if (this.usuario == null) {
                let error = { "status": 998, "message": "Acceso denegado" };
                this.handleError.redirectUrl(error)
            } else {
                let bandera = this.sessionTokenService.useJwtHelper();
                if (!bandera) {
                    this.consultarMasivo.iniciarUsuarioMasivo();
                    this.datosGeneralesIndividualSevice.datosClienteIndividual().subscribe(
                        datosClienteIndividual => {
                            this.clienteMasivosIndividual = datosClienteIndividual;
                            this.sesionStorageService.store("NombreUser", JSON.stringify(this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno));
                            sessionStorage.setItem("NombreUser", this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno);
                        },
                        error => { this.handleError.redirectUrl(error); });
                    this.otroRamoModificado = new DetallesProductosGenerales();
                    this.otroRamoOriginal = new DetallesProductosGenerales();
                    this.editar = true;
                    this.otrosRamos = jQuery.parseJSON(this.sesionStorageService.retrieve("OtrosRamosSeleccionado"));
                    this.getOtrosRamos();
                    this.sesionStorageService.observe("OtrosRamosSeleccionado").subscribe(v => {
                        this.otrosRamos = jQuery.parseJSON(v);
                        this.getOtrosRamos();
                    });
                } else {
                    this.usuarioLogin = jQuery.parseJSON(sessionStorage.getItem("usuarioLogin"));
                    let bandera = this.usuarioLogin.Tipo;
                    this.router.navigate(["/login"],bandera);
                }
            }
        } catch (e) {
            this.usuarioLogin = jQuery.parseJSON(sessionStorage.getItem("usuarioLogin"));
            let bandera = this.usuarioLogin.Tipo;
            this.router.navigate(["/login"],bandera);
        }
    }

    getOtrosRamos() {
        this.renovacionService.datosOtrosRamos(this.otrosRamos).subscribe(
            otroRamos => {
                this.otroRamoModificado = this.cloneOtroRamo(otroRamos);
                this.otroRamoOriginal = otroRamos;
                this.otroRamoModificado.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
                this.otroRamoOriginal.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
            },
            error => { this.handleError.redirectUrl(error); }
        )
    }

    editarCampos() {
        this.editar = false;
    }

    cancelarEditarCampos() {
        this.editar = true;
        this.otroRamoModificado = this.cloneOtroRamo(this.otroRamoOriginal);
        this.otroRamoModificado.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
    }

    renovarOtroRamo() {
        this.renovacionService.insertarOtroRamoRenovacion(this.otroRamoModificado).subscribe(
            result => {
                if (result) {
                    swal({
                        title: 'Renovación',
                        text: "Recuerde que los datos seran verificados por un ejecutivo, para hacer efectiva su renovación",
                        type: 'success'
                    }).then(function () {
                        window.location.reload(true);
                    });
                } else {
                    swal({
                        title: 'Renovación',
                        text: "A ocurrido un inconveniente al intentar enviar su solicitud",
                        type: 'warning'
                    }).then(function () {
                        this.router.navigate(["/error/500"]);
                    });
                }
            },
            error => { this.handleError.redirectUrl(error); }
        );
    }

    cloneOtroRamo(c: DetallesProductosGenerales) {
        let otroRamo = new DetallesProductosGenerales();
        for (let prop in c) {
            otroRamo[prop] = c[prop];
        }
        return otroRamo;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/renovaciones/renovacion-otros-ramos.component.ts